/**
 * Mapeo de rutas de API de inglés a español
 * Este archivo centraliza la traducción de rutas para mantener consistencia
 */

export const API_ROUTES = {
  // Autenticación
  AUTH: {
    LOGIN: '/auth/login',
    LOGOUT: '/auth/logout',
    REGISTER: '/auth/register',
    REFRESH: '/auth/refresh'
  },

  // Usuarios
  USERS: '/usuarios',
  USERS_BY_ID: (id) => `/usuarios/${id}`,
  USERS_BY_ROLE: (roleId) => `/usuarios/rol/${roleId}`,
  USERS_SEARCH: '/usuarios/buscar',
  USERS_STATS: '/usuarios/estadisticas/por_tipo',
  USERS_VALIDATE_DNI: '/usuarios/validar_dni',
  USERS_VALIDATE_EMAIL: '/usuarios/validar_email',
  USERS_ACTIVATE: (id) => `/usuarios/${id}/activar`,
  USERS_SUSPEND: (id) => `/usuarios/${id}/suspender`,
  USERS_DEACTIVATE: (id) => `/usuarios/${id}/desactivar`,
  USERS_IMPORT: '/usuarios/importar',
  USERS_EXPORT: '/usuarios/exportar',

  // Planes (plans -> planes)
  PLANS: '/planes',
  PLANS_BY_ID: (id) => `/planes/${id}`,
  PLAN_CONFIGURATION: '/configuracion_planes',
  ADMIN_PLAN_CONFIGURATION: '/configuracion_planes/admin',

  // Afiliados (affiliates -> afiliados)
  AFFILIATES: '/afiliados',
  AFFILIATES_BY_ID: (id) => `/afiliados/${id}`,
  AFFILIATES_BY_USER: (userId) => `/usuarios_afiliados/usuario/${userId}`,

  // Empresas (companies -> empresas)
  COMPANIES: '/empresas',
  COMPANIES_BY_ID: (id) => `/empresas/${id}`,

  // Emergencias
  EMERGENCIES: '/emergencias',
  EMERGENCIES_BY_ID: (id) => `/emergencias/${id}`,
  EMERGENCIES_PENDING: '/emergencias/pendientes',
  EMERGENCIES_ACTIVE: '/emergencias/activas',

  // Unidades Medicas
  MEDICAL_UNITS: '/unidades_medicas',
  MEDICAL_UNITS_BY_ID: (id) => `/unidades_medicas/${id}`,
  MEDICAL_UNITS_AVAILABLE: '/unidades_medicas/disponibles',

  // Contratos
  CONTRACTS: '/contratos',
  CONTRACTS_BY_ID: (id) => `/contratos/${id}`,
  CORPORATE_CONTRACTS: '/contratos/corporativos',

  // Notificaciones
  NOTIFICATIONS: '/notificaciones',
  NOTIFICATIONS_BY_ID: (id) => `/notificaciones/${id}`,
  NOTIFICATIONS_UNREAD: '/notificaciones/no_leidas',

  // Estadísticas (stats -> estadisticas)
  STATS: '/estadisticas_dashboard',
  STATS_SERVICES: '/estadisticas_servicios',
  STATS_REVENUE: '/estadisticas_dashboard/ingresos',

  // Solicitudes de registro
  REGISTRATION_REQUESTS: '/solicitudes_registro',
  REGISTRATION_APPROVE: (id) => `/solicitudes_registro/${id}/aprobar`,
  REGISTRATION_REJECT: (id) => `/solicitudes_registro/${id}/rechazar`,
  REGISTRATION_PENDING: '/solicitudes_registro/pendientes',

  // Organizaciones
  ORGANIZATIONS: '/organizaciones',
  ORGANIZATIONS_BY_ID: (id) => `/organizaciones/${id}`,

  // Entidades externas
  EXTERNAL_ENTITIES: '/entidades_externas',
  EXTERNAL_ENTITIES_BY_ID: (id) => `/entidades_externas/${id}`,

  // Configuraciones
  CONFIG: {
    SURVEYS: '/configuracion_encuestas',
    PAYMENTS: '/configuracion_pagos',
    BILLING: '/configuracion_facturacion',
    REGISTRATION: '/configuracion_registro',
    TRANSFERS: '/configuracion_transferencias'
  },

  // Encuestas
  SURVEYS: {
    QUESTIONS: '/preguntas_encuestas',
    RESPONSES: '/respuestas_encuestas',
    STATS: '/respuestas_encuestas/estadisticas'
  },

  // Reportes
  REPORTS: '/reportes_generados',
  REPORTS_GENERATE: '/reportes_generados/generar',

  // Transacciones
  TRANSACTIONS: '/transacciones',
  TRANSACTIONS_BY_ID: (id) => `/transacciones/${id}`,

  // Permisos y roles
  ROLES: '/roles',
  PERMISSIONS: '/permisos',
  ROLES_PERMISSIONS: '/roles_permisos',

  // Servicios médicos
  MEDICAL_SERVICES: '/tipos_servicios_medicos',
  SERVICE_HISTORY: '/historial_servicios',

  // Distritos
  DISTRICTS: '/distritos',

  // Unidades médicas
  MEDICAL_UNITS: '/unidades_medicas',

  // Sincronización offline
  SYNC: '/sincronizacion_offline'
}

export default API_ROUTES